/* First-purchase promo: JS side of snippets/first-purchase-price.liquid, for
   prices that change after load (variant change on the product page; later
   quickview and compare). Same markup, threshold and rounding as the snippet:
   keep both in sync. Data: window.FirstPurchase, printed in layout/theme.liquid. */
(function () {
  var fp = window.FirstPurchase;
  if (!fp) return;

  // Discounted price in cents, or null when the promo doesn't apply.
  // ">=" matches Shopify's "minimum purchase amount" (confirmed).
  fp.discounted = function (cents) {
    if (!fp.eligible || typeof cents !== 'number' || cents < fp.minCents) return null;
    return cents - Math.round(cents * fp.percent / 100);
  };

  // Updates a .price-box: fills its [data-fp-promo] slot and toggles
  // .fp-active, which strikes the base price and hides the compare price.
  fp.apply = function (box, cents) {
    if (!box) return;
    var price = fp.discounted(cents);
    var slot = box.querySelector('[data-fp-promo]');
    box.classList.toggle('fp-active', price !== null);
    if (!slot) return;
    slot.textContent = '';
    if (price === null) return;

    var priceEl = document.createElement('span');
    priceEl.className = 'fp-price';
    priceEl.innerHTML = Shopify.formatMoney(price, fp.moneyFormat); // money format may contain HTML
    var labelEl = document.createElement('span');
    labelEl.className = 'fp-label';
    labelEl.textContent = fp.label;
    slot.appendChild(priceEl);
    slot.appendChild(document.createTextNode(' '));
    slot.appendChild(labelEl);
  };
})();
